export function shouldShowBannerOnThePage(
  pathname: string,
  eligablePathsList?: Array<RegExp>,
): boolean {
  if (Array.isArray(eligablePathsList)) {
    const isEligable = eligablePathsList.some(pathRegExp => pathRegExp.test(pathname));

    return isEligable;
  }
  return true;
}
